import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-link",
  "use": "icon-icon-link-usage",
  "viewBox": "0 0 8.5 8.5",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 8.5 8.5\" id=\"icon-icon-link\">\n<path d=\"M4.7,3.8v3.7H1V3.8H4.7 M5.7,2.8H0v5.7h5.7V2.8L5.7,2.8z\" />\n<polygon points=\"8.5,6.4 7.5,6.4 7.5,1 2.3,1 2.3,0 8.5,0 \" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol